import { NguCarouselConfig } from "@ngu/carousel";
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Subject, Subscription } from "rxjs";
import { CommonService } from "src/app/services/common.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-popup-home',
  templateUrl: './popup-home.component.html',
  styleUrls: ['./popup-home.component.scss']
})
export class PopupHomeComponent implements OnInit, OnDestroy {

  listadoRecursos: any[] = [];
  registroConfiguracion: any;
  popupClosedSubscription: Subscription;
  unsubscribe$ = new Subject();

  height: number;
  width: number;
  public configuracionRecursos: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    slide: 1,
    speed: 250,
    point: {
      visible: false
    },
    load: 2,
    velocity: 0,
    touch: true,
    loop: false,
    interval: { timing: 5000 },
    easing: "cubic-bezier(0, 0, 0.2, 1)"
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PopupHomeComponent>,
    private commonService: CommonService) {

    this.popupClosedSubscription = this.commonService.popupClosedAnnounced
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(closed => {
        if (closed) {
          this.dialogRef.close();
        }
      });
  }

  ngOnInit() {
    this.listadoRecursos = this.data.listadoImagenes;
    this.registroConfiguracion = this.data.registro;
    this.width = this.data.size.width;
    this.height = this.data.size.height - (this.registroConfiguracion.titulo ? 120 : 35);

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  goToLink(url: string) {
    if (url)
      window.open(url, "_blank");
  }
}
